import React from "react";
import { Grid, LinearProgress, useTheme } from "@material-ui/core";
import { useDispositionsByName } from "../../../common/services/dispositionServices";
import { ErrorMessage } from "../../../common/ErrorMessage";
import { HistoricUserCapture } from "../../../testCommunication/common/HistoricUserCapture";
import { TestCommunicationForm } from "../../../testCommunication/common/TestComunicationForm";
import { VisualInspectionTester } from "../../../testCommunication/visualInspection/VisualInspectionTester";
import { WetLeakageTester } from "../../../testCommunication/wetLeakage/WetLeakageTester";
import { IamPanFields } from "./IamPanFields";
import { useProcedureResult } from "../../../testCommunication/common/testQueries";

export const IamPanPage = ({
    historicData,
    unitData,
    unitTypeData,
    closeHistoricModal,
    setIsSubmitting,
}: any) => {
    const theme = useTheme();

    const [selectedAsset, setSelectedAsset] = React.useState(null);
    const [clearedValues, setClearedValues] = React.useState(false);
    const [historicUser, setHistoricUser] = React.useState(null);
    const [historicDate, setHistoricDate] = React.useState(null);
    const [historicDisposition, setHistoricDisposition] = React.useState(null);
    const [startDateTime, setStartDateTime] = React.useState("");
    const {
        error: errorDispositionPassed,
        data: dispositionPassed,
        isLoading: isLoadingDispositionPassed,
        isError: isErrorDispositionPassed,
    } = useDispositionsByName("Pass");

    const {
        error: errorDispositionRequiresReview,
        data: dispositionRequiresReview,
        isLoading: isLoadingDispositionRequiresReview,
        isError: isErrorDispositionRequiresReview,
    } = useDispositionsByName("Requires Review");



          const {
            data: procedureResult,
            error: errorProcedureResult,
            isError: isErrorProcedureResult,
            isSuccess: isSuccessProcedureResult,
            isLoading: isLoadingProcedureResult,
          } = useProcedureResult(historicData?.id);
    if (isLoadingDispositionPassed || isLoadingDispositionRequiresReview) {
        return (
            <div style={theme.containerMargin}>
                <Grid
                    container
                    direction="row"
                    justify="space-between"
                    alignItems="center"
                    spacing={4}
                >
                    <Grid item xs={12}>
                        <LinearProgress />
                    </Grid>
                </Grid>
            </div>
        );
    }

    if (isErrorDispositionPassed || isErrorDispositionRequiresReview) {
        return (
            <>
                {isErrorDispositionPassed && (
                    <ErrorMessage error={errorDispositionPassed} />
                )}
                {isErrorDispositionRequiresReview && (
                    <ErrorMessage error={errorDispositionRequiresReview} />
                )}
            </>
        );
    }

    return (
        <Grid
            container
            direction="row"
            justify="space-between"
            alignItems="flex-start"
            spacing={2}
        >
            {historicData && procedureResult && (
                <Grid item xs={12}>
                <IamPanFields
                    historicUser={historicUser}
                    setHistoricUser={setHistoricUser}
                    historicDate={historicDate}
                    historicData={historicData}
                    setHistoricDate={setHistoricDate}
                    historicDisposition={historicDisposition}
                    selectedAsset={selectedAsset}
                    setHistoricDisposition={setHistoricDisposition}
                    procedureResultData={procedureResult}
                    closeHistoricModal={closeHistoricModal}
                />
            </Grid>
            )}
            
        </Grid>
    );
};
